<template>
  <div
    ref="scrollContainer"
    :class="[$style.base, { [$style.isSmall]: $screen === 's' }]"
  >
    <BaseForm :scrollContainer="scrollContainer">
      <Flex
        align="center"
        direction="column"
        :class="$style.inner"
      >
        <Intro />
        <Sections />
        <slot />
      </Flex>
    </BaseForm>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Intro from './Intro.vue';
import Sections from './Sections.vue';

export default defineComponent({
  components: {
    Intro,
    Sections,
  },
  setup() {
    const scrollContainer = ref();
    return {
      scrollContainer,
    };
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  height: calc(100vh - 100px);
  border-right: 1px solid var(--color-border);
  padding: $spacing;
  overflow-y: auto;
  background: var(--color-bg);

  &.isSmall {
    height: 100%;
    border-bottom: 1px solid var(--color-border);
  }
}
</style>
